import { render, staticRenderFns } from "./CtrlBigText.vue?vue&type=template&id=69264a93&lang=pug"
import script from "./CtrlBigText.vue?vue&type=script&lang=js"
export * from "./CtrlBigText.vue?vue&type=script&lang=js"
import style0 from "./CtrlBigText.vue?vue&type=style&index=0&id=69264a93&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports